import React from 'react';
import { brand } from '../mock/mock';

export default function WhatsAppFloat() {
  const href = `https://wa.me/${brand.whatsapp.replace(/[^\d]/g, '')}?text=${encodeURIComponent(
    brand.whatsappMsg
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="hidden md:flex flex-col items-end leading-tight bg-[#7c130f] text-[#f2d68a] px-4 py-2 rounded-l-xl rounded-tr-xl font-heading text-xs tracking-wide shadow-lg">
        <span>Chat with us on</span>
        <span className="text-[#fff8e7] font-bold text-sm">WhatsApp</span>
      </span>
      <span
        className="w-16 h-16 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
        style={{
          background: 'radial-gradient(circle at 40% 30%, #3fbf5f, #128c3e)',
          border: '3px solid #d9a63b',
          boxShadow: '0 6px 24px rgba(18,140,62,0.5)',
        }}
      >
        <svg viewBox="0 0 32 32" className="w-9 h-9 fill-white">
          <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.74 6.4L3.2 28.8l6.58-1.72a12.74 12.74 0 006.22 1.62h.01c7.06 0 12.8-5.74 12.8-12.8s-5.75-12.7-12.81-12.7zm0 23.06h-.01a10.6 10.6 0 01-5.4-1.48l-.39-.23-3.9 1.02 1.04-3.8-.25-.4a10.58 10.58 0 01-1.62-5.63c0-5.86 4.77-10.62 10.63-10.62 2.84 0 5.5 1.1 7.51 3.11a10.55 10.55 0 013.11 7.52c0 5.86-4.77 10.62-10.63 10.62zm5.83-7.95c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.55-.08-.16-.71-1.72-.98-2.35-.26-.62-.52-.54-.71-.55-.18-.01-.4-.01-.61-.01a1.17 1.17 0 00-.85.4c-.29.32-1.11 1.09-1.11 2.65 0 1.56 1.14 3.07 1.3 3.28.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.89-.77 2.16-1.52.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z" />
        </svg>
      </span>
    </a>
  );
}
